
console.log("✅ custom.js loaded");
console.log("✅ custom.js running", window.innerWidth);
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// ✅ Only run on collection pages
if (!document.body.classList.contains('template-collection')) return;

(function () {
  const BP = 989;
  if (!window.matchMedia(`(max-width:${BP}px)`).matches) return;

  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function findListButton() {
    const root =
      document.querySelector(".CollectionToolbar") ||
      document.querySelector(".collection-toolbar") ||
      document.querySelector('[data-section-type="collection"]') ||
      document;

    // 1) Try common Warehouse toolbar containers
    let btns = [
      ...root.querySelectorAll(
        ".CollectionToolbar__Layout button, .CollectionToolbar__Layout a, " +
        ".collection-toolbar__layout button, .collection-toolbar__layout a, " +
        ".LayoutSwitcher button, .LayoutSwitcher a, " +
        ".layout-switcher button, .layout-switcher a"
      ),
    ].filter(isVisible);

    // If we have 2+, list is usually the LAST one
    if (btns.length >= 2) return btns[btns.length - 1];

    // 2) Fallback: find a parent that contains exactly 2 visible SVG buttons (grid + list)
    const svgBtns = [...root.querySelectorAll("button, a")]
      .filter((el) => isVisible(el) && el.querySelector("svg"));

    for (const el of svgBtns) {
      const p = el.parentElement;
      if (!p) continue;

      const group = [...p.querySelectorAll("button, a")]
        .filter((x) => isVisible(x) && x.querySelector("svg"));

      if (group.length === 2) return group[1]; // second = list icon
    }

    return null;
  }

  function forceList() {
    const btn = findListButton();
    console.log("[forceList] list button:", btn);

    if (btn) {
      btn.click();
      return true;
    }
    return false;
  }

  // Run + retry (Shopify sections can render after DOMContentLoaded)
  let tries = 0;
  const iv = setInterval(() => {
    tries++;
    if (forceList() || tries > 40) clearInterval(iv);
  }, 200);

  document.addEventListener("DOMContentLoaded", forceList);
  document.addEventListener("shopify:section:load", forceList);
  window.addEventListener("resize", () => {
    if (window.matchMedia(`(max-width:${BP}px)`).matches) forceList();
  });
})();
